module.exports = __webpack_public_path__ + "assets/icons/ic_arrow_drop_down_24px.svg";